"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SparkleOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M12,22a2,2,0,0,1-2-2,5.963,5.963,0,0,0-5.957-5.957,2,2,0,1,1-.043-4,5.973,5.973,0,0,0,6-5.957A2.022,2.022,0,0,1,12,2a2,2,0,0,1,2,2,5.982,5.982,0,0,0,5.957,6.043H20a2,2,0,0,1,0,4A5.973,5.973,0,0,0,14,20,2,2,0,0,1,12,22ZM12,4.086a7.965,7.965,0,0,1-7.957,7.957A7.965,7.965,0,0,1,12,20a7.965,7.965,0,0,1,7.957-7.957h0A7.965,7.965,0,0,1,12,4.086Z"/><path d="M20,30a2,2,0,0,1-2-2,1.883,1.883,0,0,0-1.881-1.881H16a2,2,0,0,1,0-4h.119A1.883,1.883,0,0,0,18,20.238V20a2,2,0,0,1,4,0v.238a1.883,1.883,0,0,0,1.881,1.881H24a2,2,0,0,1,0,4h-.119A1.883,1.883,0,0,0,22,28,2,2,0,0,1,20,30Zm-4-5.881h.119A3.885,3.885,0,0,1,20,28a3.885,3.885,0,0,1,3.881-3.881h0A3.885,3.885,0,0,1,20,20.238a3.885,3.885,0,0,1-3.881,3.881Z"/><path d="M26.5,20A3.5,3.5,0,1,1,30,16.5,3.5,3.5,0,0,1,26.5,20Zm0-5A1.5,1.5,0,1,0,28,16.5,1.5,1.5,0,0,0,26.5,15Z"/>';
var SparkleOutlineSVG = function SparkleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.SparkleOutlineSVG = SparkleOutlineSVG;
SparkleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(SparkleOutlineSVG);
exports.default = _default;